const sentinel = document.querySelector('[data-infinite-scroll]')

if (sentinel?.dataset.nextUrl) {
  const section = sentinel.closest('[data-section-type]')
  let loading = false

  const observer = new IntersectionObserver(
    ([entry]) => {
      if (entry.isIntersecting) loadNext()
    },
    { rootMargin: '320px 0px' }
  )

  async function loadNext() {
    const nextUrl = sentinel.dataset.nextUrl
    if (loading || !nextUrl) return

    loading = true
    sentinel.setAttribute('aria-busy', 'true')

    try {
      const url = new URL(nextUrl, location.origin)
      if (section?.dataset.sectionId) url.searchParams.set('section_id', section.dataset.sectionId)

      const response = await fetch(url)
      if (!response.ok) throw new Error(`HTTP ${response.status}`)

      const doc = new DOMParser().parseFromString(await response.text(), 'text/html')

      document.querySelectorAll('[data-infinite-grid]').forEach((grid) => {
        const incoming = doc.querySelector(`[data-infinite-grid="${grid.dataset.infiniteGrid}"]`)
        if (incoming) grid.append(...incoming.children)
      })

      const followingUrl = doc.querySelector('[data-infinite-scroll]')?.dataset.nextUrl
      if (followingUrl) {
        sentinel.dataset.nextUrl = followingUrl
      } else {
        observer.disconnect()
        sentinel.remove()
      }

      document.dispatchEvent(new CustomEvent('product-item:reinit', { detail: { root: section } }))
      document.dispatchEvent(new CustomEvent('collection:updated'))
    } catch (error) {
      console.error('[plp] infinite scroll failed', error)
    } finally {
      loading = false
      if (sentinel.isConnected) sentinel.setAttribute('aria-busy', 'false')
    }
  }

  observer.observe(sentinel)
}
